import React from 'react';
import _orderBy from 'lodash/orderBy';

import { IconFilmRoll } from '@trqk/components';
import { locale, removeNulls } from '@trqk/utils';

import { DataCard, DataCardTable } from '../components';
import { DetectionsByProductionCompanyRow } from '.';
import {
    tooltipShim,
    DETECTIONS_BY_PRODUCTION_COMPANY_WRAPPER_ID,
} from '../../../constants';

interface DetectionsByProductionCompanyCardProps {
    data: Maybe<Maybe<InsightProductionSummaryData>[]>;
}

const earningsColor = 'quarternary';

export const DetectionsByProductionCompanyCard = ({
    data,
}: DetectionsByProductionCompanyCardProps): JSX.Element => {
    const sortedAndSlicedData = _orderBy(
        removeNulls<InsightProductionSummaryData>(data ?? []),
        ['detection_count', 'program_production_company'],
        ['desc', 'asc'],
    ).slice(0, 5);

    return (
        <DataCard
            title={
                locale.enUS.INSIGHTS.CARDS.DETECTIONS_BY_PRODUCTION_COMPANY
                    .TITLE
            }
            color={earningsColor}
            header={
                <div className="mx-10">
                    {
                        locale.enUS.INSIGHTS.CARDS
                            .DETECTIONS_BY_PRODUCTION_COMPANY.HEADER.PART_1
                    }
                    &nbsp;
                    <span className="font-semibold">
                        {
                            locale.enUS.INSIGHTS.CARDS
                                .DETECTIONS_BY_PRODUCTION_COMPANY.HEADER.PART_2
                        }
                    </span>
                </div>
            }
            Icon={IconFilmRoll}
            inInsightsIndex={false}
            wrapperId={DETECTIONS_BY_PRODUCTION_COMPANY_WRAPPER_ID}
        >
            {sortedAndSlicedData.length === 0 && (
                <div className="mx-16 mt-20 italic text-tertiary-400 text-center text-sm">
                    {
                        locale.enUS.INSIGHTS.CARDS
                            .DETECTIONS_BY_PRODUCTION_COMPANY.EMPTY_MESSAGE
                    }
                </div>
            )}
            {/*
                This keeps spacing consistent between cards that use a tooltip in the header and
                those that don't
            */}
            <div style={{ height: tooltipShim }} />
            <DataCardTable>
                {sortedAndSlicedData.map(
                    (
                        datum: InsightProductionSummaryData,
                        index: number,
                    ): JSX.Element => (
                        <DetectionsByProductionCompanyRow
                            index={index}
                            // eslint-disable-next-line react/no-array-index-key -- the use can't sort this array, so using the index as the key is safe
                            key={index}
                            datum={datum}
                        />
                    ),
                )}
            </DataCardTable>
        </DataCard>
    );
};
